export interface UmpireSuccess {
  name: string | null;

  count: number | null;
}
